import React from 'react'
import App from './components/App'
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import ErrorBoundary from "./ErrorBoundary";
import store from "./store";
import thunk from "redux-thunk";

const RootApp = (props) => {
    return(
        <ErrorBoundary><Provider store={createStore(store,applyMiddleware(thunk))}><App /></Provider></ErrorBoundary>
    )
}

export default RootApp;